<template lang="pug">
.svgIconComponent(
  v-if="iconsFolderPath && name",
  :style="iconStyles"
)
  .svg(
    v-html="html",
    :class="svgClasses"
  )
</template>

<script>
import { reactive } from 'vue'
import { publicPath } from '@/../vue.config'

const iconCache = reactive({})

export default {
  props: {
    iconsFolderPath: {
      type: String,
      default: 'assets/images/icons/'
    },
    name: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 0
    },
    originalColors: Boolean
  },
  computed: {
    imageUrl () {
      return `${publicPath}${this.iconsFolderPath}${this.name}.svg`
    },
    iconStyles () {
      return {
        width: !this.size ? '100%' : `${this.size}px`,
        height: !this.size ? '100%' : `${this.size}px`
      }
    },
    svgClasses () {
      return {
        _inheritColors: !this.originalColors
      }
    },
    html () {
      return iconCache[this.name]
    }
  },
  watch: {
    name: {
      handler () {
        const name = this.name
        if (name && iconCache[name] === undefined) {
          iconCache[name] = null
          fetch(this.imageUrl)
            .then(response => response.text())
            .then(svg => { iconCache[name] = svg })
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="sass" scoped>
.svgIconComponent
  display: grid
  > .svg
    line-height: 0

    &:deep(svg)
      width: 100%
      height: 100%

    &._inheritColors
      &:deep(svg)
        fill: currentColor
        > path,
        > rect
          fill: inherit
</style>
